import { render, staticRenderFns } from "./service-supplier-price-details.vue?vue&type=template&id=67d4a97f&"
import script from "./service-supplier-price-details.vue?vue&type=script&lang=js&"
export * from "./service-supplier-price-details.vue?vue&type=script&lang=js&"
import style0 from "./service-supplier-price-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports